
// TO DO - ARREGLAR RUTAS DE LAS PAGINAS ESTATICAS

import howBuyTemplate from './views/how-buy.html';
import TemplateHowBuyAD from './views/how-buy-adaptative.html';

//////////////
import cookiesTemplate from './views/cookies.html';
import templateCookiesAD from './views/cookies-adaptative.html';
//////////////

import faqTemplate from './views/faq.html';
import templateFaqAD from './views/faq-adaptative.html';
//////////////

import guarantyRetractionTemplate from "./views/politics-guaranty-retraction.html";
import guarantyRetractionTemplateAD from "./views/politics-guaranty-retraction-adaptative.html";

import privacityPoliticsTemplate from './views/privacity-politics.html';
import templatePrivacityAD from './views/privacity-politics-adaptative.html';
//////////////

import dataProtectionTemplate from './views/politics-data-treatment.html';
import dataProtectionTemplateAD from './views/politics-data-treatment-adaptative.html';
//////////////

import termsTemplate from './views/terms.html';
import templateTermsAD from './views/terms-adaptative.html';
//////////////

import notFoundPage from './views/not-found-page.html';
import templateNotFoundAD from './views/not-found-page-adaptative.html';
//////////////

import financialStates from './views/financial-states.html';
import financialStatesAD from './views/financial-states-adaptative.html';

import buildingPage from './views/building-page.html'

// PAGOS Y ANTICIPOS
import quotationsTemplate from './views/payments-advances/quotations.html';
import purchaseOrderTemplate from './views/payments-advances/purchase-order.html';
import AdvancesOrdersTemplate from './views/payments-advances/orders.html'

routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.privacityPolitics', {
      url: "politicas-de-privacidad",
      template: __env.adaptative ? templatePrivacityAD : privacityPoliticsTemplate
    })
    .state('home.dataProtection', {
      url: "proteccion-de-datos",
      template: __env.adaptative ? dataProtectionTemplateAD : dataProtectionTemplate
    })
    .state('home.terms', {
      url: "terminos-y-condiciones",
      template: __env.adaptative ? templateTermsAD : termsTemplate
      //  url: "/terms",
      //  template: `<terms sh-ctrl="shCtrl"></terms>`
    })

    .state('home.guarantyRetractionTemplate', {
      url: "retracto-de-compra",
      template: __env.adaptative ? guarantyRetractionTemplateAD : guarantyRetractionTemplate
    })


    .state('home.financialStates', {
      url: "estados-financieros",
      template: __env.adaptative ? financialStatesAD : financialStates
      //  url: "/terms",
      //  template: `<terms sh-ctrl="shCtrl"></terms>`
    })
    .state('home.cookies', {
      url: "cookies",
      template: __env.adaptative ? templateCookiesAD : cookiesTemplate
    })
    .state('home.faq', {
      url: "faq",
      template:  __env.adaptative ? templateFaqAD : faqTemplate
      //url: "/faq",
      //template: `<faq sh-ctrl="shCtrl"></faq>`
    })
    .state('home.404', {
      url: "404",
      template:  __env.adaptative ? templateNotFoundAD : notFoundPage
    })

        // PAGOS Y ANTICIPOS
        // .state('home.quotations', {
        //   url: "/cotizaciones",
        //   template: quotationsTemplate
        // })
        // .state('home.purchaseOrder', {
        //   url: "/orden-de-compra",
        //   template: purchaseOrderTemplate
        // })
        // .state('home.AdvancesOrders', {
        //   url: "/pedidos",
        //   template: AdvancesOrdersTemplate
        // })

    .state('home.howBuy', {
      url: "como-comprar",
      template:  __env.adaptative ? TemplateHowBuyAD : howBuyTemplate
    });

}

export default routesConfig;



/** WEBPACK FOOTER **
 ** ./www/components/shared/components/static-views/static-views.config.js
 **/